import _sortBy from 'lodash/sortBy';

export function sortVariants(product) {
  return _sortBy([...((product || {}).variants || [])], 'size.position');
}
